var Toggables = function (window, document) {
  var
    triggers,
    trgets,
    options = {},
    defaults = {
      toggledClass: 'is-toggled',
      triggerSelector: '[data-toggable="trigger"]',
      targetSelector: '[data-toggable="target"]',
      closeAllOnToggle: false,
      onToggled: false,
      offToggled: false
    };

  var _setOptions = function _setOptions(config) {
    if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
      for (var key in defaults) {
        if (!defaults.hasOwnProperty(key)) {
          continue;
        }
        options[key] = typeof config[key] === 'undefined' ? defaults[key] : config[key];
      }
    }
  };

  var _getElements = function _getElements() {
    triggers = document.querySelectorAll(options.triggerSelector);
    trgets = document.querySelectorAll(options.targetSelector);
  };

  var _closeTrgets = function _closeTrgets(triggers, trgets) {
    if (options.closeAllOnToggle) {
      for (var i = 0; i < triggers.length; i++) {
        _closeTrget(triggers[i], trgets[i]);
      }
    }
  };

  var _openTrget = function _openTrget(trigger, trget) {
    _closeTrgets(triggers, trgets);
    trigger.classList.add(options.toggledClass);
    trigger.toggled = true;
    if (typeof options.onToggled === 'function') options.onToggled(trigger, trget);
  };

  var _closeTrget = function _closeTrget(trigger, trget) {
    trigger.classList.remove(options.toggledClass);
    trigger.toggled = false;
    if (typeof options.offToggled === 'function') options.offToggled(trigger, trget);
  };

  var _toggleTrget = function _toggleTrget(trigger, trget) {
    trigger.toggled ? _closeTrget(trigger, trget) : _openTrget(trigger, trget);
  };

  var _bindListeners = function _bindListeners() {
    var len = triggers.length === trgets.length ? triggers.length : false;

    if (len === false) {
      console.warn('You\'re not providing an equal amount of triggers and targets');
      return;
    }

    var _loop = function _loop(i) {
      triggers[i].toggled = false;
      triggers[i].addEventListener('click', function(e) {
        e.preventDefault();
        _toggleTrget(this, trgets[i]);
      });
    };

    for (var i = 0; i < len; i++) {
      _loop(i);
    }
  };

  var init = function init(config) {
    _setOptions(config);
    _getElements();
    _bindListeners();
  };

  return {
    init: init
  };
}(window, document);
